export default function ChemForgeSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Atoms are built things, not given things
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Most chemistry classes teach the atom by giving you a complete
        diagram and asking you to memorize its parts — six protons here,
        six neutrons there, six electrons in those shells. That works for
        recognizing the carbon atom on a test. It doesn't work for
        understanding what an atom <em>is</em>. The proton count is the
        identity of the element. Change the protons and you change the
        element entirely. Change the neutrons and you get an isotope —
        same chemistry, different mass. Change the electrons and you get
        an ion — same nucleus, different charge. ChemForge makes you
        build these from scratch. Once you've assembled a few yourself,
        the periodic table stops being a wall of squares and starts
        feeling like the index of a catalog.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Why noble gases won't accept extra electrons
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Try adding an electron to helium in ChemForge. The forge refuses
        — politely. The reason is what makes noble gases interesting:
        helium already has a full valence shell with its two electrons.
        Neon has a full second shell with ten. Argon has a full third
        shell with eighteen. The completeness is the entire point.
        Atoms with full valence shells are stable; they don't gain or
        lose electrons under ordinary conditions. That's what "noble"
        means — chemically aloof. Watching the forge refuse a noble-gas
        ion teaches the noble-gas concept in one beat. The other
        elements aren't aloof: sodium gives away its single outer
        electron eagerly to reach a noble configuration, and chlorine
        grabs an electron just as eagerly. Sodium loses, chlorine gains,
        Na⁺ and Cl⁻ stick together — table salt. The pattern that
        explains most of inorganic chemistry comes out of this one rule.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        From Chadwick's neutron to Mendeleev's table
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        ChemForge has two named recognitions. The first is Chadwick's
        Neutron, earned by completing the first two periods cleanly.
        James Chadwick discovered the neutron in 1932 — completing the
        three-particle model of the atom that ChemForge uses. Before
        Chadwick, no one could explain why two atoms with the same
        proton count could have different masses; the isotope concept
        was a curiosity without a mechanism. After 1932, isotopes were
        atoms with extra neutrons. The second recognition is Mendeleev's
        Table, earned by discovering all 18 elements through argon.
        Dmitri Mendeleev arranged the elements by atomic weight and
        chemical behavior in 1869, and famously predicted the properties
        of germanium, gallium, and scandium from gaps in his table years
        before those elements were isolated. You're recapitulating his
        catalog — the first three periods are what he could see clearly.
        ChemForge is free, no signup, your discoveries stay on your
        device.
      </p>
    </>
  );
}
